import { DynamicStandaloneVideoReels } from '@/components/VideoReels';
import { useAppState } from '@/hooks/useAppState';
import { LabradorComponent } from '@/types/component';
import { withDebugMetadata } from 'lib/utils';

const LabradorVideoReels: LabradorComponent = ({ type, data, meta }) => {
  const { playlistId, scriptSrc } = data ?? {};
  const [{ isNativeAd }] = useAppState();
  const isInvalid = isNativeAd || !playlistId || !scriptSrc;

  if (isInvalid) {
    return null;
  }

  return (
    <DynamicStandaloneVideoReels playlistId={playlistId} scriptSrc={scriptSrc} {...withDebugMetadata({ type, meta })} />
  );
};

export default LabradorVideoReels;
